import React, { useState, useEffect } from "react"
import createPersistedState from "use-persisted-state"

const defaultContextValue = {
  events: [],
  trigger: () => {},
}

const { Provider, Consumer } = React.createContext(defaultContextValue)

const ObserverProvider = ({ children }) => {
  // set the default state
  const usePersistedState = createPersistedState(
    "com.box.developer.observable_events",
  )
  const [state, setState] = useState(defaultContextValue)
  const [events, setEvents] = usePersistedState({})

  // load any stored default value
  useEffect(() => {
    setState((state) => ({
      ...state,
      events,
      trigger: triggerEvent,
    }))
  }, [])

  // an function used to trigger new events by children
  const triggerEvent = (key, value) => {
    setEvents((events) => {
      const newEvents = { ...events }
      newEvents[key] = value

      setState((state) => ({
        ...state,
        events: newEvents,
      }))
      return newEvents
    })
  }

  return <Provider value={state}>{children}</Provider>
}

/**
 * A helper method for quickly wrapping any component
 * with the event observer
 */
/* eslint-disable react/display-name */
const withObserver = (WrappedComponent) => (props) => (
  <Consumer>
    {({ events, trigger }) => <WrappedComponent {...props} events={events} trigger={trigger} />}
  </Consumer>
)

export { ObserverProvider, withObserver }
